import location from './location';
import questions from "./questions";
import media from "./media";

const businessProfile = {
  namespaced: true,
  state: Object.assign(
    {},
    location.state,
    questions.state,
    media.state,
  ),
  getters: Object.assign(
    {},
    location.getters,
    questions.getters,
    media.getters,
  ),
  actions: Object.assign(
    {},
    location.actions,
    questions.actions,
    media.actions,
  ),
  mutations: Object.assign(
    {},
    location.mutations,
    questions.mutations,
    media.mutations,
  )
};

export default businessProfile;
